import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box } from '@mui/material';
import { parseISO, format } from 'date-fns';
import routeNames from '../../../../routes/routeNames';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';
import { CustomReactSelect, CustomButton, CustomModal, CustomCalendar } from '../../../shared';
import { BarIcon, CalendarIcon } from '../../../../assets';
import { handleHidePaidSearchButton, handleHideWebMetricsButton, handleShowAlwaysOnButton } from '../../../../utility';

const FilterBar = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    const dateRange = `${format(parseISO(startDateRange), 'MMM dd, yyyy')} -  ${format(parseISO(endDateRange), 'MMM dd, yyyy')}`;
    const {
        companyOptions, company, isOmaniChannel 
    } = useSelector((state) => state.company);
    const { userDetails: { is_admin } } = useSelector((state) => state.user);
    const [calendarOpen, setCalendarOpen] = useState(false);
    const { setCompany } = companyActions;
   
    const handleShowCalendar = () => {
        setCalendarOpen(!calendarOpen);
    };

    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
    };

    const webMetricsOnClick = () => {
        navigate(routeNames.WEB_METRICS);
    };

    const handleAlwaysOn = () => {
        navigate(routeNames.ALWAYS_ON);
    };

    const paidSearchOnClick = () => {
        navigate(routeNames.PAID_SEARCH);
    };

    return (
        <Grid container className="flex-row-space-between mb-24px mt-10px">
            <Grid item xs={8}>
                <Box className="flex-row gap-12"> 
                    <Box className="w-30" data-testid = "dashboard_company_selector">
                        <CustomReactSelect
                            customStyle={{ borderRadius: '50px' }}
                            data_test_id = "dashboard_company_selector"
                            handleFilter={handleCompanyChange}
                            isOptionsSearchable={true}
                            options={companyOptions}
                            placeholder="Select Company"
                            selectedOption={{ label: company.name, value: company.id }}
                        /> 
                    </Box>
                    {/* Select Inputs */}
                    <Box className="w-50">
                        <CustomButton
                            buttonColor="#FFFFFF"
                            data_test_id="dashboard_date_button"
                            handleClick={handleShowCalendar}
                            icon={<CalendarIcon />}
                            title={dateRange}
                            titleColor="#344054"
                        />
                        <CustomModal
                            component={<Box className="custom-modal-calendar-container">
                                <CustomCalendar closeModal={handleShowCalendar} />
                            </Box>}
                            data_test_id="dashboard_calendar_modal"
                            handleClose={handleShowCalendar}
                            modalOpen={calendarOpen}
                            onClose={handleShowCalendar}
                        />
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={4}>
                <Box className="flex-row-end gap-12">   
                    {handleShowAlwaysOnButton(company.id) ? <CustomButton 
                        buttonColor="#AD509E" 
                        data_test_id="dashboard_alwaysOn_button"
                        handleClick={handleAlwaysOn} 
                        title="Always On"
                        titleColor="#FFFFFF"

                    /> : null}
                    {(handleHideWebMetricsButton(company.id,isOmaniChannel )) ? <CustomButton
                        buttonColor="#AD509E"
                        data_test_id="dashboard_webMatrics_button"
                        handleClick={webMetricsOnClick}
                        icon={<BarIcon />}
                        title="Web Metrics"
                        titleColor="#FFFFFF"
                    /> : null}
                    {(handleHidePaidSearchButton(company.id,isOmaniChannel ) && company.id !== 104 && company.id !== 105) ? <CustomButton
                        buttonColor="#AD509E"
                        data_test_id="dashboard_paid_search_button"
                        handleClick={paidSearchOnClick}
                        title="Paid Search"
                        titleColor="#FFFFFF"
                    /> : null}
                    
                </Box>
            </Grid>
        </Grid>
    );
};

export default FilterBar;
